import { I18n } from '@front/volcanion'
import moment from 'moment'

const getExportFilename = (name, createdAt) => {
  const exportType = _.snakeCase(I18n.t(`export.name.${name}`, { defaultValue: I18n.t('export.unknown') }))
  const exportDate = moment(createdAt).format('YYYY_MM_DD')
  return `${exportDate}_${exportType}.csv`
}

export default getExportFilename
